export const STR = {
  en: {
    tagline: "Green Energy • Secure Future • Sustainable Wealth",
    corp: "Corporate Private Ltd",
    nav: { home: "Home", solar: "Solar Energy", calculator: "ROI Calculator", mining: "Mining & Minerals", media: "Media Studios", gallery: "Media Gallery", operations: "Operations Map", investors: "Investors", esg: "Sustainability", careers: "Careers", download: "Downloads", contact: "Contact" },
    portal: "Access Portal", admin: "Admin", langLabel: "EN",
    aboutUs: "About Us",
    aboutLinks: ["About Company", "Board Member Details", "Project", "Vision", "Mission", "Organization Hierarchy"],
    common: { learnMore: "Learn More", explore: "Explore", viewAll: "View All", submit: "Submit", back: "Back", live: "LIVE" },
    pillars: {
      title: "Three Core Business Verticals",
      subtitle: "A diversified conglomerate operating across clean energy, critical minerals, and digital media with utility-scale execution capability.",
      solar: { title: "Solar Energy & Renewables", desc: "450MW utility-scale photovoltaic complexes, SCADA grid infrastructure, and 25-year Power Purchase Agreements.", stat: "450 MW Operational" },
      mining: { title: "Mining & Critical Minerals", desc: "Responsible eco-mining and mineral beneficiation with zero-runoff standards and mist-spray dust suppression.", stat: "350 TPH Crushing" },
      media: { title: "Media & Digital Content", desc: "Cinematic virtual production, curved LED volume stages powered by Unreal Engine 5, and 4K HDR post-production.", stat: "12K LED Volume" },
    },
    home: {
      whyTitle: "Why OOJJAS Corporate", pillarsHeading: "Principal Business Verticals",
      partnersTitle: "Strategic Partnerships & Sovereign Capital",
      partnersDesc: "We collaborate with institutional off-takers, DISCOMs, EPC contractors, and sovereign infrastructure funds to accelerate India's green transition.",
      ctaBanner: "Ready to build sustainable infrastructure together?",
      ecosystem: "Our Ecosystem",
      instAdv: "Institutional Advantage",
      partner: "Partner With Us",
      initiate: "Initiate Partnership",
      investorRel: "Investor Relations",
      badges: ["ISO 27001:2022 Certified", "MCA Registered", "MPERB Empanelled"],
      statLabels: { solar_capacity: "Solar Capacity", co2_offset: "CO₂ Offset", projects: "Active Projects", years: "Years of Excellence" },
      visionLabel: "Our Vision",
      missionLabel: "Our Mission",
      visionText: "OOJJAS CORPORATE PRIVATE LIMITED envisions becoming a diversified corporate platform that creates long-term value through Clean Energy, Creative Media and Natural Resources.",
      missionText: "To create sustainable businesses, innovative solutions and lasting value by combining Clean Energy, Creative Media and Natural Resources with technology, integrity and responsible growth.",
    },
    showcase: {
      portfolio: "₹500 Cr+ Portfolio",
      carbon: "Carbon Negative",
      verticals: "3 Verticals • 1 Vision",
      sectors: {
        solar: { label: "Solar Energy", metric: "100+ MW Operational", status: "99.8% Efficiency" },
        media: { label: "Media & Films", metric: "25+ Film Titles", status: "Live Broadcast" },
        mining: { label: "Mining & Minerals", metric: "3 Industrial Mines", status: "Active Operations" },
      },
    },
    profile: {
      tagline: "Powering Energy. Creating Stories. Unlocking Resources.",
      intro1: "OOJJAS CORPORATE PRIVATE LIMITED is a diversified and growth-oriented company focused on building businesses across three key sectors — Solar Energy & Renewable Energy, Media & Film Making, and Mining & Minerals.",
      intro2: "The company aims to create sustainable, technology-driven and professionally managed business ventures by combining innovation, project development capabilities, strategic partnerships and long-term investment opportunities.",
      sectors: {
        solar: {
          title: "Solar Energy & Renewable Energy",
          paras: [
            "OOJJAS CORPORATE PRIVATE LIMITED is engaged in the development and promotion of solar power and renewable energy projects. The company focuses on developing, investing in, owning and operating solar power projects, including Open Access, Group Captive and other renewable energy models.",
            "Its activities may include project development, land and infrastructure development, EPC coordination, operation & maintenance, renewable energy generation and strategic partnerships for large-scale solar and hybrid renewable energy projects.",
            "The company's vision is to contribute to India's transition towards clean, reliable and sustainable energy while creating long-term value for investors and stakeholders.",
          ],
        },
        media: {
          title: "Media & Film Making",
          paras: [
            "The company also has a presence in the Media, Entertainment and Film Making sector, with a focus on developing creative and commercially viable content.",
            "Its activities include film production, short films, documentaries, digital content, web series, corporate films, advertising content, entertainment projects and other audio-visual productions.",
            "Through creative storytelling, modern production techniques and digital platforms, OOJJAS CORPORATE PRIVATE LIMITED aims to develop original content and explore opportunities across India's rapidly growing media and entertainment ecosystem.",
          ],
        },
        mining: {
          title: "Mining & Minerals",
          paras: [
            "OOJJAS CORPORATE PRIVATE LIMITED is also focused on opportunities in the Mining & Minerals sector, including mineral exploration, mine-related project development, mineral processing, mineral trading, consultancy and strategic collaborations, subject to applicable laws, approvals and regulatory requirements.",
            "The company aims to participate in responsible and professionally managed mineral-related businesses while focusing on resource efficiency, technology, environmental responsibility and sustainable value creation.",
          ],
        },
      },
      visionEyebrow: "Our Vision",
      vision1: "OOJJAS CORPORATE PRIVATE LIMITED envisions becoming a diversified corporate platform that creates long-term value through Clean Energy, Creative Media and Natural Resources.",
      vision2: "By bringing together entrepreneurial vision, professional management, strategic partnerships and responsible business practices, the company seeks to build scalable businesses that contribute to India's economic and industrial growth.",
      portfolioFocus: "Portfolio Focus",
      coreSectors: "Our Core Sectors",
      core: [
        ["SOLAR ENERGY & RENEWABLE ENERGY", "Clean Energy • Solar Power • Open Access • Group Captive • Project Development"],
        ["MEDIA & FILM MAKING", "Films • Digital Content • Web Series • Documentaries • Creative Production"],
        ["MINING & MINERALS", "Mining • Minerals • Mineral Processing • Trading • Project Development"],
      ],
      closing: "Three Sectors. One Corporate Vision.",
      closingTag: "ENERGY | ENTERTAINMENT | MINERALS",
    },
    foot: {
      desc: "A diversified Indian enterprise advancing sovereign infrastructure across clean-tech energy, critical minerals, and high-impact digital media ecosystems.",
      cols: ["Business Verticals", "Governance & ESG", "Corporate"],
      links: [
        ["Solar & Renewables", "ROI Calculator", "Mining & Minerals", "Media Studios"],
        ["Investor Relations", "Sustainability", "Media Gallery", "Careers"],
        ["Contact Secretariat", "Access Portal", "App Download", "Admin CMS"],
      ],
    },
    solarP: {
      eyebrow: "Vertical 01 — Clean Energy",
      dpr: "Request Bankable DPR",
      corpOverview: "Corporate Overview",
      title: "Solar Energy & Renewable Energy",
      p0: "OOJJAS CORPORATE PRIVATE LIMITED is engaged in the development and promotion of solar power and renewable energy projects. The company focuses on developing, investing in, owning and operating solar power projects, including Open Access, Group Captive and other renewable energy models.",
      p1: "Its activities may include project development, land and infrastructure development, EPC coordination, operation & maintenance, renewable energy generation and strategic partnerships for large-scale solar and hybrid renewable energy projects.",
      p2: "The company's vision is to contribute to India's transition towards clean, reliable and sustainable energy while creating long-term value for investors and stakeholders.",
      engScale: "Engineered for Scale",
      powering: "Powering India's Clean Energy Transition",
      features: [
        ["450 MW Utility-Scale Complex", "Rewa-Neemuch photovoltaic field with 120 central inverter blocks feeding a 220kV central pooling substation."],
        ["25-Year Power Purchase Agreements", "Bankable long-duration PPAs with DISCOMs and C&I open-access off-takers backed by escrow structures."],
        ["Live SCADA Telemetry", "Real-time generation monitoring, string-level fault detection, and automated infrared thermography scanning."],
        ["Grid-Code Compliant", "MPERC Grid Code, MNRE ALMM Order 2019, and IEEE 1547 anti-islanding safety protocols."],
      ],
      engBaseline: "Engineering Baseline",
      specTitle: "Technical Specification Dossier",
      specs: [
        ["PV Modules", "590Wp Bifacial N-Type TOPCon"],
        ["Inverter Hierarchy", "String Inverters (98.8% Peak Euro)"],
        ["Design CUF", "19.8% Central India Insolation"],
        ["Storage", "Lithium-Ion BESS 2-Hr Ready"],
      ],
      stats: [["450 MW", "Operational Capacity"], ["599 MT", "Annual CO₂ Abatement / MWp"], ["1,500", "kWh/kWp Annual Yield"], ["25 Yr", "PPA Assurance"]],
      galleryEyebrow: "Project Gallery",
      galleryTitle: "Our Solar Projects — Photos & Videos",
      gallerySub: "On-site documentation of our commissioned solar parks, tracker fields, and grid infrastructure. Administrators can upload, edit and remove project media in edit mode.",
      feasEyebrow: "Feasibility Engine",
      feasTitle: "Model your 25-year solar ROI in seconds.",
      feasDesc: "Simulate capacity, tariff savings, payback period and carbon offset instantly.",
      openCalc: "Open Calculator",
    },
    miningP: {
      eyebrow: "Vertical 02 — Critical Minerals",
      offtake: "Discuss Mineral Off-take",
      corpOverview: "Corporate Overview",
      title: "Mining & Minerals",
      p0: "OOJJAS CORPORATE PRIVATE LIMITED is also focused on opportunities in the Mining & Minerals sector, including mineral exploration, mine-related project development, mineral processing, mineral trading, consultancy and strategic collaborations, subject to applicable laws, approvals and regulatory requirements.",
      p1: "The company aims to participate in responsible and professionally managed mineral-related businesses while focusing on resource efficiency, technology, environmental responsibility and sustainable value creation.",
      respExtraction: "Responsible Extraction",
      ecoTitle: "Eco-Friendly Mining & Mineral Beneficiation",
      ecoPara: "OOJJAS operates high-grade limestone and mineral extraction in Katni, central India, combining industrial-scale throughput with uncompromising environmental stewardship and community-first development.",
      bullets: [
        "Aggregate grading & dust mitigation demonstration during production",
        "Recycling ponds with continuous particulate monitoring",
        "Community electrification and local workforce empowerment",
      ],
      opExcellence: "Operational Excellence",
      opsTitle: "Zero-Harm, High-Grade Operations",
      highlights: [
        ["Mist-Spray Dust Suppression", "Pressurised water-mist systems neutralise fine particulates during crushing and beneficiation."],
        ["Zero-Runoff Standards", "Closed-loop water recycling ponds and continuous particulate monitors ensure zero environmental discharge."],
        ["Statutory Compliance", "Full environmental clearances, cadastral survey alignment, and DGMS mine-safety adherence."],
        ["350 TPH Cone Crushers", "Modern hydraulic cone crusher plants delivering high-grade limestone and mineral aggregates."],
      ],
      galleryEyebrow: "Site Gallery",
      galleryTitle: "Our Mining Projects — Photos & Videos",
      gallerySub: "Field documentation of our quarries, beneficiation plants and eco-restoration work. Administrators can upload, caption, edit and delete media in edit mode.",
    },
    mediaP: {
      eyebrow: "Vertical 03 — Digital Media",
      viewGallery: "View Media Gallery",
      bookStudio: "Book the Studio",
      corpOverview: "Corporate Overview",
      title: "Media & Film Making",
      p0: "The company also has a presence in the Media, Entertainment and Film Making sector, with a focus on developing creative and commercially viable content.",
      p1: "Its activities include film production, short films, documentaries, digital content, web series, corporate films, advertising content, entertainment projects and other audio-visual productions.",
      p2: "Through creative storytelling, modern production techniques and digital platforms, OOJJAS CORPORATE PRIVATE LIMITED aims to develop original content and explore opportunities across India's rapidly growing media and entertainment ecosystem.",
      studioCap: "Studio Capabilities",
      cineTitle: "Cinematic Virtual Production",
      cineSub: "High-end virtual production and 4K HDR digital media studios delivering broadcast-grade content across every OOJJAS vertical.",
      cap: [
        ["Curved LED Volume Stage", "270-degree microLED photorealistic volume with real-time camera tracking powered by Unreal Engine 5."],
        ["ARRI Alexa Cinema Package", "Full 4K/8K HDR cinema camera packages with in-camera visual effects and parallax calibration."],
        ["Dolby Atmos Soundstage", "Immersive object-based audio mixing suites for broadcast, OTT, and theatrical delivery."],
        ["4K HDR Post-Production", "Color-graded documentary cuts, drone aerial surveys, and broadcast-ready master rushes."],
      ],
      projEyebrow: "Production Gallery",
      projTitle: "Studio Projects — Photos & Videos",
      projSub: "Behind-the-scenes stills and clips from our productions. Administrators can upload, caption, edit and delete media in edit mode.",
      featEyebrow: "Featured Production",
      featTitle: "Behind the Scenes: Curved LED Wall",
      featDesc: "Motion-capture calibration and dynamic parallax in-camera visual effects for premium OTT series.",
    },
    aboutP: {
      whoWeAre: "Who We Are",
      title: "About OOJJAS Corporate",
      sub: "A diversified Indian conglomerate building sustainable infrastructure across clean energy, critical minerals and digital media — governed by institutional integrity and long-term value creation.",
      corpProfile: "Corporate Profile",
      aboutCompany: "About the Company",
      body: "OOJJAS Corporate Private Limited is an integrated infrastructure enterprise headquartered in Bhopal, Madhya Pradesh. Incorporated to advance India's energy transition and resource sovereignty, we operate across three synergistic verticals — utility-scale solar generation, responsible mineral extraction, and high-fidelity digital media — combining engineering excellence with ecological accountability and disciplined institutional partnership.",
      statLabels: { solar_capacity: "Solar", co2_offset: "CO₂ Offset", projects: "Projects", years: "Years" },
      leadership: "Leadership & Governance",
      boardTitle: "Board Member Details",
      boardMember: "Board Member",
      boardNote: "Admins can edit member names, roles and photos in edit mode.",
      board: [
        ["Chairman & Managing Director", "Provides strategic vision and governance leadership across all verticals."],
        ["Executive Director — Solar Energy", "Heads utility-scale PV, SCADA grid and 25-year PPA execution."],
        ["Director — Mining & Minerals", "Leads responsible eco-mining, beneficiation and statutory compliance."],
        ["Director — Media & Studios", "Drives virtual production, broadcast and OTT content strategy."],
        ["Chief Financial Officer", "Oversees capital allocation, treasury and investor relations."],
        ["Company Secretary", "Ensures MCA governance, board charter and audit compliance."],
      ],
      portfolioEyebrow: "Portfolio",
      projectsTitle: "Our Projects",
      projectsEmpty: "Projects are managed from the Admin CMS → Projects / GIS.",
      vision: "Our Vision",
      visionBody: "OOJJAS CORPORATE PRIVATE LIMITED envisions becoming a diversified corporate platform that creates long-term value through Clean Energy, Creative Media and Natural Resources.",
      visionBody2: "By bringing together entrepreneurial vision, professional management, strategic partnerships and responsible business practices, the company seeks to build scalable businesses that contribute to India's economic and industrial growth.",
      mission: "Our Mission",
      missionBody: "To create sustainable businesses, innovative solutions and lasting value by combining Clean Energy, Creative Media and Natural Resources with technology, integrity and responsible growth.",
      structure: "Structure",
      hierarchyTitle: "Organization Hierarchy",
      hierarchy: [
        ["Board of Directors", "Apex governance & strategic oversight"],
        ["Managing Director", "Group-wide executive leadership"],
        ["Business Vertical Heads", "Solar Energy · Mining & Minerals · Media & Studios"],
        ["Functional Departments", "Finance · HR · Legal · Operations · ESG · Technology"],
        ["Site & Field Teams", "Plant engineers, mine supervisors, studio crews & field staff"],
      ],
      connect: "Connect With Our Team",
    },
    contactX: {
      secretariat: "Bhopal Corporate Secretariat",
      intro: "For institutional partnerships, off-take agreements, media, or press enquiries, connect directly with the OOJJAS corporate secretariat.",
      hq: "Registered HQ",
      hotline: "Secretariat Hotline",
      email: "Corporate Email",
      formTitle: "Initiate Official Engagement",
      ph: { name: "Full Name", email: "Email Address", phone: "Phone", company: "Company / Organisation", subject: "Subject", message: "Your message" },
      verticals: [["general", "General Enquiry"], ["solar", "Solar & PPA Off-take"], ["mining", "Mineral Off-take"], ["media", "Studio Booking"], ["investor", "Investor / JV Partnership"], ["careers", "Careers"]],
      success: "Thank you — your enquiry has been received by the OOJJAS corporate secretariat.",
    },
    investorP: {
      eyebrow: "Governance & Capital",
      title: "Investor Relations, Governance & JV Partnerships",
      sub: "Transparent disclosures, disciplined capital stewardship, and institutional-grade governance across the OOJJAS portfolio.",
      desk: "Investor Desk",
      metrics: [["₹1,240 Cr", "Assets Under Management"], ["18+", "Bankable Projects"], ["A+", "Governance Rating"], ["25 Yr", "Revenue Visibility"]],
      vault: "Disclosure Vault",
      docsTitle: "Corporate Disclosures & Filings",
      docs: [
        ["MCA Annual Filings", "ROC audited balance sheets, annual returns, and director reports filed with the Ministry of Corporate Affairs."],
        ["Statutory Approvals", "CERC tariff orders, MPERB clearances, environmental NOCs, and CEIG electrical safety certifications."],
        ["Corporate Governance", "Board charter, RBAC audit ledgers, and tamper-evident compliance documentation per ISO 27001."],
        ["Joint Ventures & EPC", "Land pooling proposals, vendor onboarding frameworks, and PPA off-taker partnership desk."],
      ],
      reqAccess: "Request Access",
    },
    esgP: {
      eyebrow: "CSR • ESG • Sustainability",
      title: "Sustainability & Community Impact",
      sub: "Ecological stewardship woven into every OOJJAS operation — from carbon-negative energy to circular resource management and inclusive community development.",
      measured: "Measured Impact",
      footprint: "Our Environmental Footprint",
      impact: [["1.2M MT", "Cumulative CO₂ Offset"], ["26,955", "Tree Saplings Equivalent / MWp"], ["1.2M L", "Thermal Water Saved Annually"], ["40+", "Villages Electrified"]],
      csr: "CSR Programmes",
      devTitle: "Development Initiatives",
      initiatives: [
        ["Carbon-Negative Energy", "Our 450MW solar portfolio abates over 599 MT of CO₂ per MWp annually, driving India toward net-zero."],
        ["Community Electrification", "Rural micro-grid programmes and last-mile connectivity for underserved villages across central India."],
        ["Local Workforce Empowerment", "Skill development, apprenticeships, and direct employment prioritising local talent near operational sites."],
      ],
    },
    galleryP: {
      eyebrow: "Archival Level — Uncompressed 4K & 8K Masters",
      title: "Corporate HD Media Gallery & Broadcast Archives",
      sub: "High-resolution photography, cinematic drone documentation, and field footage across Solar Energy, Sustainable Mining & Minerals, and Virtual Digital Media Studios.",
      cats: [["all", "All Media"], ["solar", "Solar & Utilities"], ["mining", "Mining & Minerals"], ["media", "Studio & Broadcast"]],
    },
    careersP: {
      eyebrow: "Talent Acquisition",
      title: "Build India's Sustainable Future With Us",
      sub: "Join a diversified conglomerate where engineering excellence meets ecological purpose. Explore institutional careers across energy, minerals, and media.",
      openingsEyebrow: "Current Openings",
      positions: "Open Positions",
      openings: [
        { title: "Senior Solar EPC Engineer", loc: "Neemuch, MP", type: "Full-time", vertical: "Solar Energy" },
        { title: "SCADA Telemetry Analyst", loc: "Bhopal, MP", type: "Full-time", vertical: "Grid Operations" },
        { title: "Mine Environmental Officer", loc: "Katni, MP", type: "Full-time", vertical: "Mining" },
        { title: "Virtual Production Supervisor", loc: "Bhopal Studio, MP", type: "Full-time", vertical: "Media" },
        { title: "Corporate Finance Manager", loc: "Bhopal, MP", type: "Full-time", vertical: "Corporate" },
        { title: "ESG Compliance Associate", loc: "Bhopal, MP", type: "Full-time", vertical: "Sustainability" },
      ],
      selected: "Selected",
      apply: "Apply",
      dropzone: "Resume Dropzone",
      ph: { name: "Full Name", email: "Email Address", phone: "Phone", cover: "Cover note (optional)" },
      upload: "Upload Resume (PDF / DOCX)",
      submitApp: "Submit Application",
      success: "Application submitted — our HR desk will reach out shortly.",
    },
    downloadP: {
      eyebrow: "OOJJAS Corporate Mobile App",
      title: "Your Green Infrastructure, In Your Pocket",
      sub: "Download the official OOJJAS Corporate app for live SCADA telemetry, visitor passes, and secure intranet access on the go.",
      getOn: "GET IT ON",
      dlOn: "Download on the",
      features: [
        ["Offline Resilience", "Full navigation in remote solar farms and mining pits during zero-connectivity conditions."],
        ["Push Notifications", "Real-time SCADA alerts, gate-pass approvals, and corporate announcements."],
        ["Secure Gateway", "Biometric-locked access to intranet, telemetry, and visitor management."],
      ],
    },
    accountP: {
      loading: "Loading…",
      memberAccount: "Member Account",
      sub: "Sign in to manage your visitor passes and profile.",
      signIn: "Sign In",
      register: "Register",
      namePh: "Full Name",
      emailPh: "Email",
      passPh: "Password (min 8 characters)",
      createAccount: "Create Account",
      logout: "Logout",
      myPasses: "My Visitor Passes",
      newPass: "+ New Pass",
      noPasses: "No visitor passes yet. Generate one from the Access Portal.",
      validTill: "Valid till",
      expired: "Expired",
      active: "Active",
      showQr: "Show this QR at the gate",
      welcome: "Welcome back!",
      created: "Account created. Welcome!",
      loggedOut: "Logged out",
    },
    portalX: {
      gateway: "UNIFIED GATEWAY: ACTIVE (NODE-IN-C1)",
      ssl: "256-BIT SSL ENCRYPTED",
      leftDesc: "Single gateway for operational staff, engineers, institutional off-takers, and statutory auditors.",
      cards: [
        ["Industrial SCADA & Assets", "Real-time Solar PV telemetry & dispatch logistics."],
        ["Mining & Quarry Logistics", "Weighbridge data, e-transit passes & permits."],
        ["Stakeholder & PPA Desk", "Vendor onboarding & investor compliance rooms."],
      ],
      advisoryTitle: "STATUTORY SECURITY ADVISORY:",
      advisory: "Access is strictly restricted to designated personnel and vetted stakeholders. All sessions are monitored pursuant to the Information Technology Act, 2000 and applicable national cybersecurity frameworks.",
      empTitle: "Personnel Intranet Gateway",
      empSub: "Sign in with your enterprise credentials.",
      emailLabel: "Corporate Email / Employee ID",
      passLabel: "Secret Key / Password",
      deptLabel: "Operational Department",
      depts: ["Solar Energy EPC & Grid Utility Division", "Mining & Quarry Logistics", "Media & Broadcast Studio", "Corporate Secretariat & Finance"],
      demo: "Demo admin: admin@oojjascorporate.com / Oojjas@2026",
      welcome: "Welcome",
      visitorTitle: "Encrypted Visitor Gate Pass",
      visitorSub: "Generate a single-use 12-hour QR entry pass.",
      ph: { name: "Full Name", company: "Company Name", host: "Host Employee Email", phone: "Phone", purpose: "Purpose of Visit" },
      generate: "Generate Encrypted QR Pass",
      gateStaff: "Gate staff? Verify a pass code →",
      passActive: "Gate Pass Active",
      validUntil: "Valid until",
      presentQr: "Present this encrypted QR at the Bhopal HQ turnstile. Single-use, 12-hour TTL.",
      print: "Print Pass",
      another: "Generate Another Pass",
      verifyTitle: "Gate Verification",
      verifySub: "Enter a pass code to verify entry status.",
      verifyPh: "Pass Code (e.g. OJ-XXXXXXXX)",
      verifyBtn: "Verify",
      expired: "Expired",
      activeOk: "Active — Entry Allowed",
      backToPass: "← Back to Pass Generation",
    },
    calcX: {
      engine: "Renewable Yield & LCOE Assessment Engine",
      params: "System Parameters",
      estCapex: "Estimated Capex (Turnkey EPC)",
      year1: "Year 1 generation",
      overYears: "Over {years} years",
      breakeven: "Break-even milestone",
      annualAbatement: "Annual CO₂ abatement",
      cashflow: "Cumulative Cashflow & Payback Curve",
      netCashflow: "Net Cashflow",
      yearsUnit: "Years",
      yrs: "Yrs",
    },
    solar: { hero: "Utility-Scale Solar & SCADA Grid", heroSub: "India's clean energy transition, engineered at 450MW scale with bankable performance and 25-year assurance." },
    calc: {
      title: "Solar ROI & PPA Tariff Calculator",
      subtitle: "Simulate enterprise-grade solar feasibility, tariff savings, accelerated depreciation, and 25-year payback schedules — all computed instantly in your browser.",
      capacity: "System Capacity (kWp)", tariff: "Current Grid Tariff (₹/kWh)", area: "Available Area (sq.ft)", years: "PPA Duration (Years)",
      results: "Feasibility Dossier", annualGen: "Annual Generation", savings25: "25-Year Savings", payback: "Payback Period", co2: "Annual CO₂ Offset",
    },
    portalPage: { title: "Unified Dual-Access Portal", employee: "Employee & Staff Login", visitor: "Visitor & Partner Pass", member: "Member Login", signIn: "Sign In to Intranet", genPass: "Generate Gate Pass" },
    contactPage: { title: "Direct Corporate Engagement", send: "Send Enquiry" },
    hub: { breaking: "Breaking", printDigital: "Print & Digital", epaperTitle: "Flash Current News — e-Paper",
      bureau: "Press Bureau & Newswire", bureauTitle: "Video & News Updates", readSource: "Read source",
      ott: "OOJJAS OTT Originals", ottTitle: "Web Series & Short Films",
      all: "All", shorts: "Shorts", series: "Series", short: "Short",
      noTitles: "No titles yet. Upload your first web series or short film.",
      upload: "Upload", add: "Add", publish: "Publish",
      liveBadge: "Live", broadcastNet: "OOJJAS Broadcast Network",
      liveTvTitle: "Online Live TV & 24×7 Channel",
      liveTvDesc: "Watch our round-the-clock news and entertainment stream — live coverage of energy, infrastructure, and cultural programming direct from the OOJJAS studios.",
      visitChannel: "Visit Our Channel", streamUrl: "Live stream embed URL", channelLink: "Channel link",
    },
    mapP: { eyebrow: "Our Footprint", title: "Operations & Project Map", sub: "Explore OOJJAS project sites across Madhya Pradesh — solar parks, mineral operations and media studios on an interactive map.", legend: "Legend", note: "Pins are plotted from live project coordinates managed in the Admin CMS.", verticals: { solar: "Solar Energy", mining: "Mining & Minerals", media: "Media & Studios" } },
  },
  hi: {
    tagline: "हरित ऊर्जा • सुरक्षित भविष्य • सतत समृद्धि",
    corp: "कॉर्पोरेट प्राइवेट लिमिटेड",
    nav: { home: "होम", solar: "सौर ऊर्जा", calculator: "ROI कैलकुलेटर", mining: "खनन एवं खनिज", media: "मीडिया स्टूडियो", gallery: "मीडिया गैलरी", operations: "ऑपरेशन्स मैप", investors: "निवेशक", esg: "स्थिरता", careers: "करियर", download: "डाउनलोड", contact: "संपर्क" },
    portal: "एक्सेस पोर्टल", admin: "एडमिन", langLabel: "हिं",
    aboutUs: "हमारे बारे में",
    aboutLinks: ["कंपनी के बारे में", "बोर्ड सदस्य विवरण", "परियोजनाएं", "दृष्टि", "मिशन", "संगठनात्मक ढांचा"],
    common: { learnMore: "और जानें", explore: "देखें", viewAll: "सभी देखें", submit: "जमा करें", back: "वापस", live: "लाइव" },
    pillars: {
      title: "तीन प्रमुख व्यापार क्षेत्र",
      subtitle: "स्वच्छ ऊर्जा, महत्वपूर्ण खनिज एवं डिजिटल मीडिया में उपयोगिता-स्तरीय निष्पादन क्षमता के साथ एक विविधीकृत समूह।",
      solar: { title: "सौर ऊर्जा एवं नवीकरणीय", desc: "450MW उपयोगिता-स्तरीय फोटोवोल्टिक परिसर, SCADA ग्रिड अवसंरचना एवं 25-वर्षीय विद्युत क्रय समझौते।", stat: "450 MW परिचालित" },
      mining: { title: "खनन एवं महत्वपूर्ण खनिज", desc: "शून्य-अपवाह मानकों एवं मिस्ट-स्प्रे धूल दमन के साथ उत्तरदायी इको-माइनिंग एवं खनिज संवर्धन।", stat: "350 TPH क्रशिंग" },
      media: { title: "मीडिया एवं डिजिटल कंटेंट", desc: "सिनेमैटिक वर्चुअल प्रोडक्शन, अनरियल इंजन 5 संचालित LED वॉल्यूम स्टेज एवं 4K HDR पोस्ट-प्रोडक्शन।", stat: "12K LED वॉल्यूम" },
    },
    home: {
      whyTitle: "क्यों ओजस कॉर्पोरेट", pillarsHeading: "प्रमुख व्यापार क्षेत्र",
      partnersTitle: "रणनीतिक साझेदारी एवं संप्रभु पूंजी",
      partnersDesc: "हम भारत के हरित परिवर्तन को गति देने के लिए संस्थागत ऑफ-टेकर्स, DISCOMs, EPC ठेकेदारों एवं संप्रभु अवसंरचना निधियों के साथ सहयोग करते हैं।",
      ctaBanner: "मिलकर सतत अवसंरचना बनाने के लिए तैयार हैं?",
      ecosystem: "हमारा इकोसिस्टम",
      instAdv: "संस्थागत विशेषाधिकार",
      partner: "हमसे साझेदारी करें",
      initiate: "साझेदारी शुरू करें",
      investorRel: "निवेशक संबंध",
      badges: ["ISO 27001:2022 प्रमाणित", "MCA पंजीकृत", "MPERB सूचीबद्ध"],
      statLabels: { solar_capacity: "सौर क्षमता", co2_offset: "CO₂ कटौती", projects: "सक्रिय परियोजनाएं", years: "उत्कृष्टता के वर्ष" },
      visionLabel: "हमारी दृष्टि",
      missionLabel: "हमारा मिशन",
      visionText: "ओजस कॉर्पोरेट प्राइवेट लिमिटेड स्वच्छ ऊर्जा, रचनात्मक मीडिया एवं प्राकृतिक संसाधनों के माध्यम से दीर्घकालिक मूल्य सृजित करने वाला एक विविधीकृत कॉर्पोरेट मंच बनने की परिकल्पना करता है।",
      missionText: "प्रौद्योगिकी, सत्यनिष्ठा एवं जिम्मेदार विकास के साथ स्वच्छ ऊर्जा, रचनात्मक मीडिया एवं प्राकृतिक संसाधनों को मिलाकर सतत व्यवसाय, नवीन समाधान एवं स्थायी मूल्य सृजित करना।",
    },
    showcase: {
      portfolio: "₹500 करोड़+ पोर्टफोलियो",
      carbon: "कार्बन निगेटिव",
      verticals: "3 क्षेत्र • 1 दृष्टि",
      sectors: {
        solar: { label: "सौर ऊर्जा", metric: "100+ MW परिचालित", status: "99.8% दक्षता" },
        media: { label: "मीडिया एवं फिल्में", metric: "25+ फिल्म शीर्षक", status: "लाइव प्रसारण" },
        mining: { label: "खनन एवं खनिज", metric: "3 औद्योगिक खानें", status: "सक्रिय संचालन" },
      },
    },
    profile: {
      tagline: "ऊर्जा को सशक्त बनाना। कहानियाँ रचना। संसाधनों को अनलॉक करना।",
      intro1: "ओजस कॉर्पोरेट प्राइवेट लिमिटेड एक विविधीकृत एवं विकास-उन्मुख कंपनी है जो तीन प्रमुख क्षेत्रों — सौर ऊर्जा एवं नवीकरणीय ऊर्जा, मीडिया एवं फिल्म निर्माण, तथा खनन एवं खनिज — में व्यवसाय स्थापित करने पर केंद्रित है।",
      intro2: "कंपनी का लक्ष्य नवाचार, परियोजना विकास क्षमताओं, रणनीतिक साझेदारियों एवं दीर्घकालिक निवेश अवसरों को मिलाकर सतत, प्रौद्योगिकी-संचालित एवं व्यावसायिक रूप से प्रबंधित व्यावसायिक उद्यम स्थापित करना है।",
      sectors: {
        solar: {
          title: "सौर ऊर्जा एवं नवीकरणीय ऊर्जा",
          paras: [
            "ओजस कॉर्पोरेट प्राइवेट लिमिटेड सौर ऊर्जा एवं नवीकरणीय ऊर्जा परियोजनाओं के विकास एवं संवर्धन में संलग्न है। कंपनी ओपन एक्सेस, ग्रुप कैप्टिव एवं अन्य नवीकरणीय ऊर्जा मॉडल सहित सौर ऊर्जा परियोजनाओं के विकास, निवेश, स्वामित्व एवं संचालन पर ध्यान केंद्रित करती है।",
            "इसकी गतिविधियों में परियोजना विकास, भूमि एवं अवसंरचना विकास, EPC समन्वय, संचालन एवं रखरखाव, नवीकरणीय ऊर्जा उत्पादन तथा बड़े पैमाने की सौर एवं हाइब्रिड नवीकरणीय ऊर्जा परियोजनाओं के लिए रणनीतिक साझेदारियाँ शामिल हो सकती हैं।",
            "कंपनी की दृष्टि निवेशकों एवं हितधारकों के लिए दीर्घकालिक मूल्य सृजित करते हुए स्वच्छ, विश्वसनीय एवं सतत ऊर्जा की ओर भारत के परिवर्तन में योगदान देना है।",
          ],
        },
        media: {
          title: "मीडिया एवं फिल्म निर्माण",
          paras: [
            "कंपनी की मीडिया, मनोरंजन एवं फिल्म निर्माण क्षेत्र में भी उपस्थिति है, जिसका फोकस रचनात्मक एवं व्यावसायिक रूप से व्यवहार्य कंटेंट विकसित करने पर है।",
            "इसकी गतिविधियों में फिल्म निर्माण, लघु फिल्में, डॉक्यूमेंट्री, डिजिटल कंटेंट, वेब सीरीज़, कॉर्पोरेट फिल्में, विज्ञापन कंटेंट, मनोरंजन परियोजनाएं एवं अन्य ऑडियो-विज़ुअल प्रोडक्शन शामिल हैं।",
            "रचनात्मक कथा-कथन, आधुनिक प्रोडक्शन तकनीकों एवं डिजिटल प्लेटफ़ॉर्म के माध्यम से ओजस कॉर्पोरेट प्राइवेट लिमिटेड का लक्ष्य मौलिक कंटेंट विकसित करना एवं भारत के तेज़ी से बढ़ते मीडिया एवं मनोरंजन इकोसिस्टम में अवसरों का पता लगाना है।",
          ],
        },
        mining: {
          title: "खनन एवं खनिज",
          paras: [
            "ओजस कॉर्पोरेट प्राइवेट लिमिटेड खनन एवं खनिज क्षेत्र के अवसरों पर भी केंद्रित है, जिसमें खनिज अन्वेषण, खान-संबंधी परियोजना विकास, खनिज प्रसंस्करण, खनिज व्यापार, परामर्श एवं रणनीतिक सहयोग शामिल हैं — लागू कानूनों, स्वीकृतियों एवं नियामक आवश्यकताओं के अधीन।",
            "कंपनी का लक्ष्य संसाधन दक्षता, प्रौद्योगिकी, पर्यावरणीय उत्तरदायित्व एवं सतत मूल्य सृजन पर ध्यान केंद्रित करते हुए जिम्मेदार एवं व्यावसायिक रूप से प्रबंधित खनिज-संबंधी व्यवसायों में भाग लेना है।",
          ],
        },
      },
      visionEyebrow: "हमारी दृष्टि",
      vision1: "ओजस कॉर्पोरेट प्राइवेट लिमिटेड स्वच्छ ऊर्जा, रचनात्मक मीडिया एवं प्राकृतिक संसाधनों के माध्यम से दीर्घकालिक मूल्य सृजित करने वाला एक विविधीकृत कॉर्पोरेट मंच बनने की परिकल्पना करता है।",
      vision2: "उद्यमशीलता की दृष्टि, व्यावसायिक प्रबंधन, रणनीतिक साझेदारियों एवं जिम्मेदार व्यावसायिक प्रथाओं को एक साथ लाकर कंपनी ऐसे स्केलेबल व्यवसाय बनाना चाहती है जो भारत के आर्थिक एवं औद्योगिक विकास में योगदान दें।",
      portfolioFocus: "पोर्टफोलियो फोकस",
      coreSectors: "हमारे प्रमुख क्षेत्र",
      core: [
        ["सौर ऊर्जा एवं नवीकरणीय ऊर्जा", "स्वच्छ ऊर्जा • सौर ऊर्जा • ओपन एक्सेस • ग्रुप कैप्टिव • परियोजना विकास"],
        ["मीडिया एवं फिल्म निर्माण", "फिल्में • डिजिटल कंटेंट • वेब सीरीज़ • डॉक्यूमेंट्री • रचनात्मक प्रोडक्शन"],
        ["खनन एवं खनिज", "खनन • खनिज • खनिज प्रसंस्करण • व्यापार • परियोजना विकास"],
      ],
      closing: "तीन क्षेत्र। एक कॉर्पोरेट दृष्टि।",
      closingTag: "ऊर्जा | मनोरंजन | खनिज",
    },
    foot: {
      desc: "स्वच्छ-तकनीक ऊर्जा, महत्वपूर्ण खनिजों एवं उच्च-प्रभाव डिजिटल मीडिया इकोसिस्टम में संप्रभु अवसंरचना को आगे बढ़ाने वाला एक विविधीकृत भारतीय उद्यम।",
      cols: ["व्यापार क्षेत्र", "शासन एवं ESG", "कॉर्पोरेट"],
      links: [
        ["सौर एवं नवीकरणीय", "ROI कैलकुलेटर", "खनन एवं खनिज", "मीडिया स्टूडियो"],
        ["निवेशक संबंध", "स्थिरता", "मीडिया गैलरी", "करियर"],
        ["सचिवालय संपर्क", "एक्सेस पोर्टल", "ऐप डाउनलोड", "एडमिन CMS"],
      ],
    },
    solarP: {
      eyebrow: "क्षेत्र 01 — स्वच्छ ऊर्जा",
      dpr: "बैंक योग्य DPR का अनुरोध करें",
      corpOverview: "कॉर्पोरेट अवलोकन",
      title: "सौर ऊर्जा एवं नवीकरणीय ऊर्जा",
      p0: "ओजस कॉर्पोरेट प्राइवेट लिमिटेड सौर ऊर्जा एवं नवीकरणीय ऊर्जा परियोजनाओं के विकास एवं संवर्धन में संलग्न है। कंपनी ओपन एक्सेस, ग्रुप कैप्टिव एवं अन्य नवीकरणीय ऊर्जा मॉडल सहित सौर ऊर्जा परियोजनाओं के विकास, निवेश, स्वामित्व एवं संचालन पर ध्यान केंद्रित करती है।",
      p1: "इसकी गतिविधियों में परियोजना विकास, भूमि एवं अवसंरचना विकास, EPC समन्वय, संचालन एवं रखरखाव, नवीकरणीय ऊर्जा उत्पादन तथा बड़े पैमाने की सौर एवं हाइब्रिड नवीकरणीय ऊर्जा परियोजनाओं के लिए रणनीतिक साझेदारियाँ शामिल हो सकती हैं।",
      p2: "कंपनी की दृष्टि निवेशकों एवं हितधारकों के लिए दीर्घकालिक मूल्य सृजित करते हुए स्वच्छ, विश्वसनीय एवं सतत ऊर्जा की ओर भारत के परिवर्तन में योगदान देना है।",
      engScale: "विस्तार के लिए इंजीनियर्ड",
      powering: "भारत के स्वच्छ ऊर्जा परिवर्तन को सशक्त बनाना",
      features: [
        ["450 MW उपयोगिता-स्तरीय परिसर", "220kV केंद्रीय पूलिंग सबस्टेशन को फीड करने वाले 120 केंद्रीय इन्वर्टर ब्लॉक के साथ रीवा-नीमच फोटोवोल्टिक क्षेत्र।"],
        ["25-वर्षीय विद्युत क्रय समझौते", "एस्क्रो संरचनाओं से समर्थित DISCOMs एवं C&I ओपन-एक्सेस ऑफ-टेकर्स के साथ बैंक योग्य दीर्घकालिक PPA।"],
        ["लाइव SCADA टेलीमेट्री", "रीयल-टाइम उत्पादन मॉनिटरिंग, स्ट्रिंग-स्तरीय फॉल्ट डिटेक्शन एवं स्वचालित इन्फ्रारेड थर्मोग्राफी स्कैनिंग।"],
        ["ग्रिड-कोड अनुरूप", "MPERC ग्रिड कोड, MNRE ALMM आदेश 2019 एवं IEEE 1547 एंटी-आइलैंडिंग सुरक्षा प्रोटोकॉल।"],
      ],
      engBaseline: "इंजीनियरिंग आधार",
      specTitle: "तकनीकी विनिर्देश दस्तावेज़",
      specs: [
        ["PV मॉड्यूल", "590Wp Bifacial N-Type TOPCon"],
        ["इन्वर्टर पदानुक्रम", "स्ट्रिंग इन्वर्टर (98.8% पीक यूरो)"],
        ["डिज़ाइन CUF", "19.8% मध्य भारत इंसोलेशन"],
        ["स्टोरेज", "लिथियम-आयन BESS 2-घंटा रेडी"],
      ],
      stats: [["450 MW", "परिचालन क्षमता"], ["599 MT", "वार्षिक CO₂ न्यूनीकरण / MWp"], ["1,500", "kWh/kWp वार्षिक उत्पादन"], ["25 वर्ष", "PPA आश्वासन"]],
      galleryEyebrow: "परियोजना गैलरी",
      galleryTitle: "हमारी सौर परियोजनाएं — फोटो एवं वीडियो",
      gallerySub: "हमारे कमीशन किए गए सौर पार्कों, ट्रैकर फील्ड्स एवं ग्रिड अवसंरचना का ऑन-साइट दस्तावेज़ीकरण। एडमिन एडिट मोड में परियोजना मीडिया अपलोड, संपादित एवं हटा सकते हैं।",
      feasEyebrow: "व्यवहार्यता इंजन",
      feasTitle: "अपने 25-वर्षीय सौर ROI का मॉडल कुछ ही सेकंड में बनाएं।",
      feasDesc: "क्षमता, टैरिफ बचत, पेबैक अवधि एवं कार्बन ऑफसेट का तुरंत अनुकरण करें।",
      openCalc: "कैलकुलेटर खोलें",
    },
    miningP: {
      eyebrow: "क्षेत्र 02 — महत्वपूर्ण खनिज",
      offtake: "खनिज ऑफ-टेक पर चर्चा करें",
      corpOverview: "कॉर्पोरेट अवलोकन",
      title: "खनन एवं खनिज",
      p0: "ओजस कॉर्पोरेट प्राइवेट लिमिटेड खनन एवं खनिज क्षेत्र के अवसरों पर भी केंद्रित है, जिसमें खनिज अन्वेषण, खान-संबंधी परियोजना विकास, खनिज प्रसंस्करण, खनिज व्यापार, परामर्श एवं रणनीतिक सहयोग शामिल हैं — लागू कानूनों, स्वीकृतियों एवं नियामक आवश्यकताओं के अधीन।",
      p1: "कंपनी का लक्ष्य संसाधन दक्षता, प्रौद्योगिकी, पर्यावरणीय उत्तरदायित्व एवं सतत मूल्य सृजन पर ध्यान केंद्रित करते हुए जिम्मेदार एवं व्यावसायिक रूप से प्रबंधित खनिज-संबंधी व्यवसायों में भाग लेना है।",
      respExtraction: "जिम्मेदार उत्खनन",
      ecoTitle: "इको-फ्रेंडली खनन एवं खनिज संवर्धन",
      ecoPara: "ओजस मध्य भारत के कटनी में उच्च-ग्रेड चूना-पत्थर एवं खनिज उत्खनन संचालित करता है — औद्योगिक-स्तरीय उत्पादन क्षमता को अटूट पर्यावरणीय संरक्षण एवं समुदाय-प्रथम विकास के साथ जोड़ते हुए।",
      bullets: [
        "उत्पादन के दौरान एग्रीगेट ग्रेडिंग एवं धूल न्यूनीकरण प्रदर्शन",
        "निरंतर पार्टिकुलेट मॉनिटरिंग के साथ रीसाइक्लिंग तालाब",
        "सामुदायिक विद्युतीकरण एवं स्थानीय कार्यबल सशक्तिकरण",
      ],
      opExcellence: "परिचालन उत्कृष्टता",
      opsTitle: "शून्य-हानि, उच्च-ग्रेड संचालन",
      highlights: [
        ["मिस्ट-स्प्रे धूल दमन", "क्रशिंग एवं संवर्धन के दौरान दाबयुक्त वॉटर-मिस्ट सिस्टम महीन कणों को बेअसर करते हैं।"],
        ["शून्य-अपवाह मानक", "क्लोज़्ड-लूप जल पुनर्चक्रण तालाब एवं निरंतर पार्टिकुलेट मॉनिटर शून्य पर्यावरणीय निर्वहन सुनिश्चित करते हैं।"],
        ["वैधानिक अनुपालन", "पूर्ण पर्यावरणीय मंज़ूरियाँ, कैडास्ट्रल सर्वे संरेखण एवं DGMS खान-सुरक्षा पालन।"],
        ["350 TPH कोन क्रशर", "उच्च-ग्रेड चूना-पत्थर एवं खनिज एग्रीगेट देने वाले आधुनिक हाइड्रोलिक कोन क्रशर प्लांट।"],
      ],
      galleryEyebrow: "साइट गैलरी",
      galleryTitle: "हमारी खनन परियोजनाएं — फोटो एवं वीडियो",
      gallerySub: "हमारी खदानों, संवर्धन संयंत्रों एवं इको-रिस्टोरेशन कार्यों का फील्ड दस्तावेज़ीकरण। एडमिन एडिट मोड में मीडिया अपलोड, कैप्शन, संपादित एवं हटा सकते हैं।",
    },
    mediaP: {
      eyebrow: "क्षेत्र 03 — डिजिटल मीडिया",
      viewGallery: "मीडिया गैलरी देखें",
      bookStudio: "स्टूडियो बुक करें",
      corpOverview: "कॉर्पोरेट अवलोकन",
      title: "मीडिया एवं फिल्म निर्माण",
      p0: "कंपनी की मीडिया, मनोरंजन एवं फिल्म निर्माण क्षेत्र में भी उपस्थिति है, जिसका फोकस रचनात्मक एवं व्यावसायिक रूप से व्यवहार्य कंटेंट विकसित करने पर है।",
      p1: "इसकी गतिविधियों में फिल्म निर्माण, लघु फिल्में, डॉक्यूमेंट्री, डिजिटल कंटेंट, वेब सीरीज़, कॉर्पोरेट फिल्में, विज्ञापन कंटेंट, मनोरंजन परियोजनाएं एवं अन्य ऑडियो-विज़ुअल प्रोडक्शन शामिल हैं।",
      p2: "रचनात्मक कथा-कथन, आधुनिक प्रोडक्शन तकनीकों एवं डिजिटल प्लेटफ़ॉर्म के माध्यम से ओजस कॉर्पोरेट प्राइवेट लिमिटेड का लक्ष्य मौलिक कंटेंट विकसित करना एवं भारत के तेज़ी से बढ़ते मीडिया एवं मनोरंजन इकोसिस्टम में अवसरों का पता लगाना है।",
      studioCap: "स्टूडियो क्षमताएं",
      cineTitle: "सिनेमैटिक वर्चुअल प्रोडक्शन",
      cineSub: "हाई-एंड वर्चुअल प्रोडक्शन एवं 4K HDR डिजिटल मीडिया स्टूडियो जो हर ओजस क्षेत्र में ब्रॉडकास्ट-ग्रेड कंटेंट देते हैं।",
      cap: [
        ["कर्व्ड LED वॉल्यूम स्टेज", "अनरियल इंजन 5 संचालित रीयल-टाइम कैमरा ट्रैकिंग के साथ 270-डिग्री microLED फोटोरियलिस्टिक वॉल्यूम।"],
        ["ARRI एलेक्सा सिनेमा पैकेज", "इन-कैमरा विज़ुअल इफेक्ट्स एवं पैरालैक्स कैलिब्रेशन के साथ पूर्ण 4K/8K HDR सिनेमा कैमरा पैकेज।"],
        ["डॉल्बी एटमॉस साउंडस्टेज", "ब्रॉडकास्ट, OTT एवं थिएट्रिकल डिलीवरी के लिए इमर्सिव ऑब्जेक्ट-आधारित ऑडियो मिक्सिंग सूट।"],
        ["4K HDR पोस्ट-प्रोडक्शन", "कलर-ग्रेडेड डॉक्यूमेंट्री कट, ड्रोन एरियल सर्वे एवं ब्रॉडकास्ट-रेडी मास्टर रशेज़।"],
      ],
      projEyebrow: "प्रोडक्शन गैलरी",
      projTitle: "स्टूडियो परियोजनाएं — फोटो एवं वीडियो",
      projSub: "हमारे प्रोडक्शन के बिहाइंड-द-सीन स्टिल्स एवं क्लिप्स। एडमिन एडिट मोड में मीडिया अपलोड, कैप्शन, संपादित एवं हटा सकते हैं।",
      featEyebrow: "विशेष प्रोडक्शन",
      featTitle: "बिहाइंड द सीन्स: कर्व्ड LED वॉल",
      featDesc: "प्रीमियम OTT सीरीज़ के लिए मोशन-कैप्चर कैलिब्रेशन एवं डायनामिक पैरालैक्स इन-कैमरा विज़ुअल इफेक्ट्स।",
    },
    aboutP: {
      whoWeAre: "हम कौन हैं",
      title: "ओजस कॉर्पोरेट के बारे में",
      sub: "स्वच्छ ऊर्जा, महत्वपूर्ण खनिजों एवं डिजिटल मीडिया में सतत अवसंरचना बनाने वाला एक विविधीकृत भारतीय समूह — संस्थागत सत्यनिष्ठा एवं दीर्घकालिक मूल्य सृजन से शासित।",
      corpProfile: "कॉर्पोरेट प्रोफाइल",
      aboutCompany: "कंपनी के बारे में",
      body: "ओजस कॉर्पोरेट प्राइवेट लिमिटेड एक एकीकृत अवसंरचना उद्यम है जिसका मुख्यालय भोपाल, मध्य प्रदेश में है। भारत के ऊर्जा परिवर्तन एवं संसाधन संप्रभुता को आगे बढ़ाने के लिए स्थापित, हम तीन समन्वयकारी क्षेत्रों — उपयोगिता-स्तरीय सौर उत्पादन, जिम्मेदार खनिज उत्खनन एवं उच्च-निष्ठा डिजिटल मीडिया — में कार्य करते हैं, इंजीनियरिंग उत्कृष्टता को पारिस्थितिक जवाबदेही एवं अनुशासित संस्थागत साझेदारी के साथ जोड़ते हुए।",
      statLabels: { solar_capacity: "सौर", co2_offset: "CO₂ कटौती", projects: "परियोजनाएं", years: "वर्ष" },
      leadership: "नेतृत्व एवं शासन",
      boardTitle: "बोर्ड सदस्य विवरण",
      boardMember: "बोर्ड सदस्य",
      boardNote: "एडमिन एडिट मोड में सदस्यों के नाम, पद एवं फोटो संपादित कर सकते हैं।",
      board: [
        ["अध्यक्ष एवं प्रबंध निदेशक", "सभी क्षेत्रों में रणनीतिक दृष्टि एवं शासन नेतृत्व प्रदान करते हैं।"],
        ["कार्यकारी निदेशक — सौर ऊर्जा", "उपयोगिता-स्तरीय PV, SCADA ग्रिड एवं 25-वर्षीय PPA निष्पादन का नेतृत्व करते हैं।"],
        ["निदेशक — खनन एवं खनिज", "जिम्मेदार इको-माइनिंग, संवर्धन एवं वैधानिक अनुपालन का नेतृत्व करते हैं।"],
        ["निदेशक — मीडिया एवं स्टूडियो", "वर्चुअल प्रोडक्शन, ब्रॉडकास्ट एवं OTT कंटेंट रणनीति चलाते हैं।"],
        ["मुख्य वित्तीय अधिकारी", "पूंजी आवंटन, ट्रेज़री एवं निवेशक संबंधों की देखरेख करते हैं।"],
        ["कंपनी सचिव", "MCA शासन, बोर्ड चार्टर एवं ऑडिट अनुपालन सुनिश्चित करते हैं।"],
      ],
      portfolioEyebrow: "पोर्टफोलियो",
      projectsTitle: "हमारी परियोजनाएं",
      projectsEmpty: "परियोजनाएं एडमिन CMS → Projects / GIS से प्रबंधित की जाती हैं।",
      vision: "हमारी दृष्टि",
      visionBody: "ओजस कॉर्पोरेट प्राइवेट लिमिटेड स्वच्छ ऊर्जा, रचनात्मक मीडिया एवं प्राकृतिक संसाधनों के माध्यम से दीर्घकालिक मूल्य सृजित करने वाला एक विविधीकृत कॉर्पोरेट मंच बनने की परिकल्पना करता है।",
      visionBody2: "उद्यमशीलता की दृष्टि, व्यावसायिक प्रबंधन, रणनीतिक साझेदारियों एवं जिम्मेदार व्यावसायिक प्रथाओं को एक साथ लाकर कंपनी ऐसे स्केलेबल व्यवसाय बनाना चाहती है जो भारत के आर्थिक एवं औद्योगिक विकास में योगदान दें।",
      mission: "हमारा मिशन",
      missionBody: "प्रौद्योगिकी, सत्यनिष्ठा एवं जिम्मेदार विकास के साथ स्वच्छ ऊर्जा, रचनात्मक मीडिया एवं प्राकृतिक संसाधनों को मिलाकर सतत व्यवसाय, नवीन समाधान एवं स्थायी मूल्य सृजित करना।",
      structure: "संरचना",
      hierarchyTitle: "संगठनात्मक ढांचा",
      hierarchy: [
        ["बोर्ड ऑफ डायरेक्टर्स", "शीर्ष शासन एवं रणनीतिक निरीक्षण"],
        ["प्रबंध निदेशक", "समूह-व्यापी कार्यकारी नेतृत्व"],
        ["व्यापार क्षेत्र प्रमुख", "सौर ऊर्जा · खनन एवं खनिज · मीडिया एवं स्टूडियो"],
        ["कार्यात्मक विभाग", "वित्त · HR · लीगल · ऑपरेशंस · ESG · टेक्नोलॉजी"],
        ["साइट एवं फील्ड टीमें", "प्लांट इंजीनियर, खान सुपरवाइज़र, स्टूडियो क्रू एवं फील्ड स्टाफ"],
      ],
      connect: "हमारी टीम से जुड़ें",
    },
    contactX: {
      secretariat: "भोपाल कॉर्पोरेट सचिवालय",
      intro: "संस्थागत साझेदारियों, ऑफ-टेक समझौतों, मीडिया या प्रेस पूछताछ के लिए सीधे ओजस कॉर्पोरेट सचिवालय से संपर्क करें।",
      hq: "पंजीकृत मुख्यालय",
      hotline: "सचिवालय हॉटलाइन",
      email: "कॉर्पोरेट ईमेल",
      formTitle: "आधिकारिक संपर्क शुरू करें",
      ph: { name: "पूरा नाम", email: "ईमेल पता", phone: "फ़ोन", company: "कंपनी / संगठन", subject: "विषय", message: "आपका संदेश" },
      verticals: [["general", "सामान्य पूछताछ"], ["solar", "सौर एवं PPA ऑफ-टेक"], ["mining", "खनिज ऑफ-टेक"], ["media", "स्टूडियो बुकिंग"], ["investor", "निवेशक / JV साझेदारी"], ["careers", "करियर"]],
      success: "धन्यवाद — आपकी पूछताछ ओजस कॉर्पोरेट सचिवालय को प्राप्त हो गई है।",
    },
    investorP: {
      eyebrow: "शासन एवं पूंजी",
      title: "निवेशक संबंध, शासन एवं JV साझेदारियाँ",
      sub: "ओजस पोर्टफोलियो में पारदर्शी प्रकटीकरण, अनुशासित पूंजी प्रबंधन एवं संस्थागत-स्तरीय शासन।",
      desk: "निवेशक डेस्क",
      metrics: [["₹1,240 करोड़", "प्रबंधनाधीन परिसंपत्तियां"], ["18+", "बैंक योग्य परियोजनाएं"], ["A+", "शासन रेटिंग"], ["25 वर्ष", "राजस्व दृश्यता"]],
      vault: "प्रकटीकरण वॉल्ट",
      docsTitle: "कॉर्पोरेट प्रकटीकरण एवं फाइलिंग",
      docs: [
        ["MCA वार्षिक फाइलिंग", "कॉर्पोरेट मामलों के मंत्रालय में दाखिल ROC ऑडिटेड बैलेंस शीट, वार्षिक रिटर्न एवं निदेशक रिपोर्ट।"],
        ["वैधानिक स्वीकृतियाँ", "CERC टैरिफ आदेश, MPERB क्लीयरेंस, पर्यावरणीय NOC एवं CEIG विद्युत सुरक्षा प्रमाणन।"],
        ["कॉर्पोरेट गवर्नेंस", "ISO 27001 के अनुसार बोर्ड चार्टर, RBAC ऑडिट लेजर एवं छेड़छाड़-रोधी अनुपालन दस्तावेज़।"],
        ["जॉइंट वेंचर एवं EPC", "भूमि पूलिंग प्रस्ताव, विक्रेता ऑनबोर्डिंग फ्रेमवर्क एवं PPA ऑफ-टेकर साझेदारी डेस्क।"],
      ],
      reqAccess: "एक्सेस का अनुरोध करें",
    },
    esgP: {
      eyebrow: "CSR • ESG • स्थिरता",
      title: "स्थिरता एवं सामुदायिक प्रभाव",
      sub: "हर ओजस संचालन में बुनी गई पारिस्थितिक देखभाल — कार्बन-निगेटिव ऊर्जा से लेकर चक्रीय संसाधन प्रबंधन एवं समावेशी सामुदायिक विकास तक।",
      measured: "मापा गया प्रभाव",
      footprint: "हमारा पर्यावरणीय पदचिह्न",
      impact: [["1.2M MT", "संचयी CO₂ कटौती"], ["26,955", "वृक्ष साप्लिंग समतुल्य / MWp"], ["1.2M लीटर", "वार्षिक तापीय जल बचत"], ["40+", "विद्युतीकृत गाँव"]],
      csr: "CSR कार्यक्रम",
      devTitle: "विकास पहल",
      initiatives: [
        ["कार्बन-निगेटिव ऊर्जा", "हमारा 450MW सौर पोर्टफोलियो प्रति MWp वार्षिक 599 MT से अधिक CO₂ कम करता है, जो भारत को नेट-ज़ीरो की ओर ले जाता है।"],
        ["सामुदायिक विद्युतीकरण", "मध्य भारत के वंचित गाँवों के लिए ग्रामीण माइक्रो-ग्रिड कार्यक्रम एवं अंतिम-मील कनेक्टिविटी।"],
        ["स्थानीय कार्यबल सशक्तिकरण", "परिचालन साइटों के निकट स्थानीय प्रतिभा को प्राथमिकता देते हुए कौशल विकास, अपरेंटिसशिप एवं प्रत्यक्ष रोज़गार।"],
      ],
    },
    galleryP: {
      eyebrow: "आर्काइवल स्तर — अनकंप्रेस्ड 4K एवं 8K मास्टर",
      title: "कॉर्पोरेट HD मीडिया गैलरी एवं ब्रॉडकास्ट आर्काइव",
      sub: "सौर ऊर्जा, सतत खनन एवं खनिज, तथा वर्चुअल डिजिटल मीडिया स्टूडियो में उच्च-रिज़ॉल्यूशन फोटोग्राफी, सिनेमैटिक ड्रोन दस्तावेज़ीकरण एवं फील्ड फुटेज।",
      cats: [["all", "सभी मीडिया"], ["solar", "सौर एवं यूटिलिटी"], ["mining", "खनन एवं खनिज"], ["media", "स्टूडियो एवं ब्रॉडकास्ट"]],
    },
    careersP: {
      eyebrow: "प्रतिभा अधिग्रहण",
      title: "हमारे साथ भारत का सतत भविष्य बनाएं",
      sub: "एक ऐसे विविधीकृत समूह से जुड़ें जहाँ इंजीनियरिंग उत्कृष्टता पारिस्थितिक उद्देश्य से मिलती है। ऊर्जा, खनिज एवं मीडिया में संस्थागत करियर खोजें।",
      openingsEyebrow: "वर्तमान रिक्तियां",
      positions: "रिक्त पद",
      openings: [
        { title: "वरिष्ठ सौर EPC इंजीनियर", loc: "नीमच, MP", type: "पूर्णकालिक", vertical: "सौर ऊर्जा" },
        { title: "SCADA टेलीमेट्री विश्लेषक", loc: "भोपाल, MP", type: "पूर्णकालिक", vertical: "ग्रिड ऑपरेशंस" },
        { title: "खान पर्यावरण अधिकारी", loc: "कटनी, MP", type: "पूर्णकालिक", vertical: "खनन" },
        { title: "वर्चुअल प्रोडक्शन सुपरवाइज़र", loc: "भोपाल स्टूडियो, MP", type: "पूर्णकालिक", vertical: "मीडिया" },
        { title: "कॉर्पोरेट वित्त प्रबंधक", loc: "भोपाल, MP", type: "पूर्णकालिक", vertical: "कॉर्पोरेट" },
        { title: "ESG अनुपालन सहयोगी", loc: "भोपाल, MP", type: "पूर्णकालिक", vertical: "स्थिरता" },
      ],
      selected: "चयनित",
      apply: "आवेदन करें",
      dropzone: "रिज्यूमे अपलोड करें",
      ph: { name: "पूरा नाम", email: "ईमेल पता", phone: "फ़ोन", cover: "कवर नोट (वैकल्पिक)" },
      upload: "रिज्यूमे अपलोड करें (PDF / DOCX)",
      submitApp: "आवेदन जमा करें",
      success: "आवेदन जमा हो गया — हमारी HR टीम शीघ्र संपर्क करेगी।",
    },
    downloadP: {
      eyebrow: "ओजस कॉर्पोरेट मोबाइल ऐप",
      title: "आपकी ग्रीन अवसंरचना, आपकी जेब में",
      sub: "लाइव SCADA टेलीमेट्री, विज़िटर पास एवं सुरक्षित इंट्रानेट एक्सेस के लिए आधिकारिक ओजस कॉर्पोरेट ऐप डाउनलोड करें।",
      getOn: "पाएं",
      dlOn: "डाउनलोड करें",
      features: [
        ["ऑफलाइन मजबूती", "शून्य-कनेक्टिविटी परिस्थितियों में दूरस्थ सौर फार्म एवं खदानों में पूर्ण नेविगेशन।"],
        ["पुश नोटिफिकेशन", "रीयल-टाइम SCADA अलर्ट, गेट-पास स्वीकृतियाँ एवं कॉर्पोरेट घोषणाएं।"],
        ["सुरक्षित गेटवे", "इंट्रानेट, टेलीमेट्री एवं विज़िटर प्रबंधन तक बायोमेट्रिक-लॉक्ड एक्सेस।"],
      ],
    },
    accountP: {
      loading: "लोड हो रहा है…",
      memberAccount: "सदस्य खाता",
      sub: "अपने विज़िटर पास एवं प्रोफाइल प्रबंधित करने के लिए साइन इन करें।",
      signIn: "साइन इन",
      register: "रजिस्टर",
      namePh: "पूरा नाम",
      emailPh: "ईमेल",
      passPh: "पासवर्ड (न्यूनतम 8 अक्षर)",
      createAccount: "खाता बनाएं",
      logout: "लॉगआउट",
      myPasses: "मेरे विज़िटर पास",
      newPass: "+ नया पास",
      noPasses: "अभी कोई विज़िटर पास नहीं है। एक्सेस पोर्टल से एक बनाएं।",
      validTill: "वैधता",
      expired: "समाप्त",
      active: "सक्रिय",
      showQr: "गेट पर यह QR दिखाएं",
      welcome: "वापसी पर स्वागत है!",
      created: "खाता बन गया। स्वागत है!",
      loggedOut: "लॉगआउट हो गया",
    },
    portalX: {
      gateway: "यूनिफाइड गेटवे: सक्रिय (NODE-IN-C1)",
      ssl: "256-बिट SSL एन्क्रिप्टेड",
      leftDesc: "परिचालन कर्मचारियों, इंजीनियरों, संस्थागत ऑफ-टेकर्स एवं वैधानिक ऑडिटरों के लिए एकल गेटवे।",
      cards: [
        ["औद्योगिक SCADA एवं परिसंपत्तियां", "रीयल-टाइम सौर PV टेलीमेट्री एवं डिस्पैच लॉजिस्टिक्स।"],
        ["खनन एवं खदान लॉजिस्टिक्स", "वेब्रिज डेटा, ई-ट्रांजिट पास एवं परमिट।"],
        ["हितधारक एवं PPA डेस्क", "विक्रेता ऑनबोर्डिंग एवं निवेशक अनुपालन रूम।"],
      ],
      advisoryTitle: "वैधानिक सुरक्षा परामर्श:",
      advisory: "पहुंच केवल नामित कर्मियों एवं जाँचे गए हितधारकों तक सीमित है। सभी सत्र सूचना प्रौद्योगिकी अधिनियम, 2000 एवं लागू राष्ट्रीय साइबर सुरक्षा ढांचे के अनुसार मॉनिटर किए जाते हैं।",
      empTitle: "कार्मिक इंट्रानेट गेटवे",
      empSub: "अपने एंटरप्राइज़ क्रेडेंशियल से साइन इन करें।",
      emailLabel: "कॉर्पोरेट ईमेल / कर्मचारी ID",
      passLabel: "गुप्त कुंजी / पासवर्ड",
      deptLabel: "परिचालन विभाग",
      depts: ["सौर ऊर्जा EPC एवं ग्रिड यूटिलिटी प्रभाग", "खनन एवं खदान लॉजिस्टिक्स", "मीडिया एवं ब्रॉडकास्ट स्टूडियो", "कॉर्पोरेट सचिवालय एवं वित्त"],
      demo: "डेमो एडमिन: admin@oojjascorporate.com / Oojjas@2026",
      welcome: "स्वागत है",
      visitorTitle: "एन्क्रिप्टेड विज़िटर गेट पास",
      visitorSub: "सिंगल-उपयोग 12-घंटे का QR एंट्री पास बनाएं।",
      ph: { name: "पूरा नाम", company: "कंपनी का नाम", host: "होस्ट कर्मचारी ईमेल", phone: "फ़ोन", purpose: "आने का उद्देश्य" },
      generate: "एन्क्रिप्टेड QR पास बनाएं",
      gateStaff: "गेट स्टाफ? पास कोड सत्यापित करें →",
      passActive: "गेट पास सक्रिय",
      validUntil: "वैधता",
      presentQr: "भोपाल HQ टर्नस्टाइल पर यह एन्क्रिप्टेड QR दिखाएं। सिंगल-उपयोग, 12-घंटे की TTL।",
      print: "पास प्रिंट करें",
      another: "दूसरा पास बनाएं",
      verifyTitle: "गेट सत्यापन",
      verifySub: "एंट्री स्थिति सत्यापित करने के लिए पास कोड दर्ज करें।",
      verifyPh: "पास कोड (जैसे OJ-XXXXXXXX)",
      verifyBtn: "सत्यापित करें",
      expired: "समाप्त",
      activeOk: "सक्रिय — प्रवेश अनुमत",
      backToPass: "← पास जनरेशन पर वापस जाएं",
    },
    calcX: {
      engine: "नवीकरणीय उत्पादन एवं LCOE मूल्यांकन इंजन",
      params: "प्रणाली मापदंड",
      estCapex: "अनुमानित कैपेक्स (टर्नकी EPC)",
      year1: "पहले वर्ष का उत्पादन",
      overYears: "{years} वर्षों में",
      breakeven: "ब्रेक-ईवन माइलस्टोन",
      annualAbatement: "वार्षिक CO₂ न्यूनीकरण",
      cashflow: "संचयी कैशफ्लो एवं पेबैक वक्र",
      netCashflow: "शुद्ध कैशफ्लो",
      yearsUnit: "वर्ष",
      yrs: "वर्ष",
    },
    solar: { hero: "उपयोगिता-स्तरीय सौर ऊर्जा एवं SCADA ग्रिड", heroSub: "भारत का स्वच्छ ऊर्जा परिवर्तन, 450MW स्तर पर इंजीनियर्ड एवं 25-वर्षीय आश्वासन के साथ।" },
    calc: {
      title: "सौर ROI एवं PPA टैरिफ कैलकुलेटर",
      subtitle: "एंटरप्राइज़-स्तरीय सौर व्यवहार्यता, टैरिफ बचत, त्वरित मूल्यह्रास एवं 25-वर्षीय पेबैक अनुसूची का तत्काल अनुकरण करें।",
      capacity: "प्रणाली क्षमता (kWp)", tariff: "वर्तमान ग्रिड टैरिफ (₹/kWh)", area: "उपलब्ध क्षेत्र (वर्ग फुट)", years: "PPA अवधि (वर्ष)",
      results: "व्यवहार्यता रिपोर्ट", annualGen: "वार्षिक उत्पादन", savings25: "25-वर्षीय बचत", payback: "पेबैक अवधि", co2: "वार्षिक CO₂ ऑफसेट",
    },
    portalPage: { title: "एकीकृत दोहरी-पहुंच पोर्टल", employee: "कर्मचारी लॉगिन", visitor: "विज़िटर एवं पार्टनर पास", member: "सदस्य लॉगिन", signIn: "इंट्रानेट में साइन इन करें", genPass: "गेट पास बनाएं" },
    contactPage: { title: "प्रत्यक्ष कॉर्पोरेट संपर्क", send: "पूछताछ भेजें" },
    hub: {
      breaking: "ब्रेकिंग", printDigital: "प्रिंट एवं डिजिटल", epaperTitle: "फ्लैश ताज़ा खबरें — ई-पेपर",
      bureau: "प्रेस ब्यूरो एवं न्यूज़वायर", bureauTitle: "वीडियो एवं समाचार अपडेट", readSource: "स्रोत पढ़ें",
      ott: "ओजस OTT ओरिजिनल्स", ottTitle: "वेब सीरीज़ एवं लघु फिल्में",
      all: "सभी", shorts: "शॉर्ट्स", series: "सीरीज़", short: "शॉर्ट",
      noTitles: "अभी कोई शीर्षक नहीं। अपनी पहली वेब सीरीज़ या लघु फिल्म अपलोड करें।",
      upload: "अपलोड", add: "जोड़ें", publish: "प्रकाशित करें",
      liveBadge: "लाइव", broadcastNet: "ओजस ब्रॉडकास्ट नेटवर्क",
      liveTvTitle: "ऑनलाइन लाइव TV एवं 24×7 चैनल",
      liveTvDesc: "ऊर्जा, अवसंरचना एवं सांस्कृतिक प्रोग्रामिंग की सीधी लाइव कवरेज — ओजस स्टूडियो से चौबीसों घंटे समाचार एवं मनोरंजन स्ट्रीम देखें।",
      visitChannel: "हमारा चैनल देखें", streamUrl: "लाइव स्ट्रीम एम्बेड URL", channelLink: "चैनल लिंक",
    },
    mapP: { eyebrow: "हमारी उपस्थिति", title: "ऑपरेशन्स एवं परियोजना मैप", sub: "मध्य प्रदेश भर में ओजस की परियोजना साइटें — सौर पार्क, खनिज संचालन एवं मीडिया स्टूडियो एक इंटरैक्टिव मैप पर देखें।", legend: "लेजेंड", note: "पिन एडमिन CMS में प्रबंधित लाइव परियोजना निर्देशांकों से प्लॉट किए गए हैं।", verticals: { solar: "सौर ऊर्जा", mining: "खनन एवं खनिज", media: "मीडिया एवं स्टूडियो" } },
  },
};
